/*
 *
 * UsersDetail reducer
 *
 */
import produce from 'immer';
import {
  FLUSH_STATE,
  LOAD_USER,
  LOAD_USER_SUCCESS,
  LOAD_USER_ERROR,
  CHANGE_USER,
  CHANGE_USER_SUCCESS,
  CHANGE_USER_ERROR,
} from './constants';

export const initialState = {
  firstRender: true,
  loading: false,
  error: false,
  userData: false,
  id: false,
};

/* eslint-disable default-case, no-param-reassign */
const usersDetailReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;

      // Load User
      case LOAD_USER:
        draft.loading = true;
        draft.error = false;
        draft.id = action.id;
        break;

      case LOAD_USER_SUCCESS:
        draft.userData = action.userData;
        draft.loading = false;
        draft.firstRender = false;
        break;

      case LOAD_USER_ERROR:
        draft.error = action.error;
        draft.loading = false;
        break;
      
      
    }
  });

export default usersDetailReducer;
